import React from 'react';
import { HeroVariant61 } from '../components/HeroVariant61';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage61() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1738">
      <Navigation data-id="element-1739" />
      <main data-id="element-1740">
        <HeroVariant61 data-id="element-1741" />
        <WhyUs data-id="element-1742" />
        <Services data-id="element-1743" />
        <FAQ data-id="element-1744" />
        <Testimonials data-id="element-1745" />
        <Consultation data-id="element-1746" />
      </main>
      <Footer data-id="element-1747" />
      <CookieBanner data-id="element-1748" />
      <FloatingContact data-id="element-1749" />
    </div>;
}